<template>
    <div class="ConnaitreEngagement">
        <HeadPage :title="'Notre engagement qualité'" 
                  :category="'Nous connaitre'"
                  :img="'nous-connaitre/engagement.jpg'"
                  :imgAlt="'Engagement head page'"
        />
        <ContentPage :content="content"
        />
        <div class="ConnaitreEngagement-Signature">
            <span>Pascal PHILIPPE,</span>
            <span>Directeur de JobStream</span>
            <img src="/img/nous-connaitre/signature.png" alt="Signature">
        </div>
    </div>
</template>

<script>
import HeadPage from '../global/HeadPage.vue'
import ContentPage from '../global/ContentPage.vue'

export default {
    name: "ConnaitreEngagement",
    data() {
        return {
            content: [
                { 
                    title: 'Lettre d\'engagement Qualité', 
                    text: [ `<strong>JobStream</strong> est un cabinet de conseil en Ressources Humaines et un organisme de formation qui propose des prestations 
                    d'accompagnement et de formation à destination des demandeurs d\'emploi et des salariés d'entreprise. 
                    <strong>JobStream</strong> intervient également pour le compte d'organismes de formation partenaires.`,
                    `<strong>JobStream</strong> s'inscrit dans une démarche volontariste d'amélioration continue de la 
                    qualité de ses services et des prestations de formation et d'accompagnement qui lui sont confiées. 
                    Cette démarche qualité, mise en oeuvre dès l'information du public jusqu'au suivi postformation des stagiaires, 
                    se décline comme suit :`,
                    `<strong>JobStream</strong> s'engage à :`,
                    `<ul>
                        <li>Informer le public sur l'offre de formation, les délais et les conditions d'accès et le cas 
                        échéant des résultats obtenus lors des épreuves de positionnement,</li>
                        <li>Délivrer une formation adaptée aux besoins de l'apprenant, pour faciliter son accès ou son maintien 
                        dans l'emploi,</li>
                        <li>S'assurer de l'adéquation de ses outils pédagogiques avec le niveau de chaque apprenant,</li>
                        <li>Adapter régulièrement les compétences professionnelles de ses intervenants et mesurer la pertinence de 
                        ses méthodes pédagogiques.</li>
                        <li>Prendre en compte les appréciations rendues par les stagiaires et par les commanditaires, pour améliorer la 
                        qualité des prestations.</li>
                    </ul>`,
                    `Fait à Aix-en-Provence, le 15 juin 2021`
                        ]
                }
            ]
        }
    },
    components: {
        HeadPage,
        ContentPage
    }
}
</script>

<style scoped>
/* 
* Global 
*/ 
.ConnaitreEngagement-Signature {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    align-content: flex-end;
    width: 75%;
    padding-bottom: 50px;
}

.ConnaitreEngagement-Signature img {
    width: 200px;
    margin: auto;
}
</style>